import { Box, Typography } from "@mui/material";
import DatesFilter from "components/search-filters/dates-filter";
import { useState } from "react";

const BookingDates = ({ onChange, values }: { onChange: any; values: any }) => {
  return (
    <Box>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "24px",
          lineHeight: "31px",
          color: "#323232",
          mb: "15px",
        }}
      >
        When will you plan to rent?
      </Typography>
      <DatesFilter onChange={onChange} values={values} />
    </Box>
  );
};

export default BookingDates;
